import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { setIdBloqueo } from '../../../../actions'

function Tabla(props){

    useEffect(() => {
        setBloqueos(props.bloqueos.data ?? []);
    },[props.bloqueos.data]);

    const [bloqueos, setBloqueos] = useState([]);
    const [filtroLoteria, setFiltroLoteria] = useState('');
    const [filtroModalidad, setFiltroModalidad] = useState('');
    const [filtroTipoBloqueo, setFiltroTipoBloqueo] = useState('');

    const loteriasOptions = [...new Set(bloqueos.map((item) => item.loteria).filter(Boolean))].sort();
    const modalidadesOptions = [...new Set(bloqueos.map((item) => item.modalidad).filter(Boolean))].sort();
    const tiposBloqueoOptions = [...new Set(bloqueos.map((item) => item.tipo_bloqueo).filter(Boolean))].sort();

    const bloqueosFiltrados = bloqueos.filter((item) => {
        const loteriaMatch = item.loteria?.toLowerCase().includes(filtroLoteria.toLowerCase());
        const modalidadMatch = item.modalidad?.toLowerCase().includes(filtroModalidad.toLowerCase());
        const tipoMatch = item.tipo_bloqueo?.toLowerCase().includes(filtroTipoBloqueo.toLowerCase());

        return loteriaMatch && modalidadMatch && tipoMatch;
    });

    const skeletonRows = Array.from({ length: 6 }, (_, index) => ({ id: index }));

    const loteriaBodyTemplate = (rowData) => rowData.loteria;

    const modalidadBodyTemplate = (rowData) => {
        const className = rowData.modalidad === 'APUESTA'
            ? 'text-success'
            : rowData.modalidad === 'QUINTA'
                ? 'text-info'
                : 'text-primary';

        return <b className={className}>{rowData.modalidad}</b>;
    };

    const tipoBloqueoBodyTemplate = (rowData) => (
        <span className={rowData.tipo_bloqueo === 'cifras' ? 'badge rounded-pill text-bg-warning m-1' : 'badge rounded-pill text-bg-primary m-1' }>
            {rowData.tipo_bloqueo?.toLowerCase()}
        </span>
    );

    const valorTipoBodyTemplate = (rowData) => <b>{rowData.valor_tipo_bloqueo}</b>;

    const combinadoBodyTemplate = (rowData) => (
        <b>
            {rowData.modalidad === 'APUESTA' || rowData.modalidad === 'TIEMPOS' || rowData.modalidad === 'SORTEOS'
                ? rowData.combinado === 1 ? 'SI' : 'NO'
                : 'NO APLICA'}
        </b>
    );

    const valorVentaBodyTemplate = (rowData) => (
        Math.floor(rowData.valor_venta).toLocaleString('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 })
    );

    const valorCubiertaBodyTemplate = (rowData) => (
        Math.floor(rowData.valor_cubierta).toLocaleString('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 })
    );

    const estadoBodyTemplate = (rowData) => (
        rowData.estado_id == '1' ? <p className='text-success m-0'>Activo</p> : <p className='text-danger m-0'>Inactivo</p>
    );

    const accionBodyTemplate = (rowData) => (
        <button 
            type="button" 
            className="btn btn-outline-primary btn-sm"
            title="Ver Loteria" 
            data-bs-toggle="modal" 
            data-bs-target="#modalEditarBloqueo"
            onClick={() => props.setIdBloqueo(rowData.id_bloqueo)}
        >
            <i className="bi bi-gear"></i>
        </button>
    );

    const skeletonTextBody = () => <Skeleton width="100%" height="1.8rem"></Skeleton>;
    const skeletonActionBody = () => <Skeleton width="3rem" height="2rem"></Skeleton>;

    return(
        <React.Fragment>
            <div className="card">
                <div className="card-body">
                    <div className='row'>
                        <div className='col-md-3 pt-4'>
                            <label className="mb-1">Filtrar por lotería</label>
                            <select
                                className="form-select"
                                value={filtroLoteria}
                                onChange={(e) => setFiltroLoteria(e.target.value)}
                            >
                                <option value="">Todas</option>
                                {loteriasOptions.map((option) => (
                                    <option key={option} value={option}>{option}</option>
                                ))}
                            </select>
                        </div>
                        <div className='col-md-3 pt-4'>
                            <label className="mb-1">Filtrar por modalidad</label>
                            <select
                                className="form-select"
                                value={filtroModalidad}
                                onChange={(e) => setFiltroModalidad(e.target.value)}
                            >
                                <option value="">Todas</option>
                                {modalidadesOptions.map((option) => (
                                    <option key={option} value={option}>{option}</option>
                                ))}
                            </select>
                        </div>
                        <div className='col-md-3 pt-4'>
                            <label className="mb-1">Filtrar por tipo</label>
                            <select
                                className="form-select"
                                value={filtroTipoBloqueo}
                                onChange={(e) => setFiltroTipoBloqueo(e.target.value)}
                            >
                                <option value="">Todos</option>
                                {tiposBloqueoOptions.map((option) => (
                                    <option key={option} value={option}>{option}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-3 align-self-end pt-4">
                            <div style={{ textAlign : 'right' }}>
                                <button 
                                    type="button" 
                                    className="btn btn-primary"
                                    data-bs-toggle="modal" 
                                    data-bs-target="#modalCrearBloqueo"
                                >
                                    Crear Bloqueo
                                </button>
                            </div>
                        </div>

                        <div className='col-md-12 pt-3'>
                            {props.bloqueos.data === undefined ? (
                                <DataTable value={skeletonRows} size="small">
                                    <Column header="Lotería" body={skeletonTextBody}></Column>
                                    <Column header="Modalidad" body={skeletonTextBody}></Column>
                                    <Column header="Tipo Bloqueo" body={skeletonTextBody}></Column>
                                    <Column header="Cifras / Numero" body={skeletonTextBody}></Column>
                                    <Column header="Combinado" body={skeletonTextBody}></Column>
                                    <Column header="$ Valor" body={skeletonTextBody}></Column>
                                    {props.data_sesion.venta_cubierta === 1 ? <Column header="$ Valor Cubierta" body={skeletonTextBody}></Column> : ''}
                                    <Column header="Estado" body={skeletonTextBody}></Column>
                                    <Column header="Ver" body={skeletonActionBody}></Column>
                                </DataTable>
                            ) : (
                                <DataTable
                                    value={bloqueosFiltrados}
                                    dataKey="id_bloqueo"
                                    size="small"
                                    rowHover
                                    sortMode="multiple"
                                    emptyMessage="No hay bloqueos para mostrar"
                                    responsiveLayout="scroll"
                                >
                                    <Column field="loteria" header="Lotería" body={loteriaBodyTemplate} sortable></Column>
                                    <Column field="modalidad" header="Modalidad" body={modalidadBodyTemplate} sortable></Column>
                                    <Column field="tipo_bloqueo" header="Tipo Bloqueo" body={tipoBloqueoBodyTemplate} sortable></Column>
                                    <Column field="valor_tipo_bloqueo" header="Cifras / Numero" body={valorTipoBodyTemplate} sortable></Column>
                                    <Column field="combinado" header="Combinado" body={combinadoBodyTemplate}></Column>
                                    <Column field="valor_venta" header="$ Valor" body={valorVentaBodyTemplate} sortable></Column>
                                    {props.data_sesion.venta_cubierta === 1 ? <Column field="valor_cubierta" header="$ Valor Cubierta" body={valorCubiertaBodyTemplate} sortable></Column> : ''}
                                    <Column field="estado_id" header="Estado" body={estadoBodyTemplate} sortable></Column>
                                    <Column header="Ver" body={accionBodyTemplate}></Column>
                                </DataTable>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

const mapSateToProps = state => {
    return {
        bloqueos: state.bloqueos,
        data_sesion: state.data_sesion
    }
}

const mapDispatchToProps  = {
    setIdBloqueo
};

export default connect(mapSateToProps, mapDispatchToProps)(Tabla)
